import { MyTypo } from "../../utils/typography/typographier";

function CardMobile3({ coach }) {
  return (
    <div className="cardTertiary">
      <div className="cardTertiary-containerContains">
        <div className="cardTertiary-containerContains-containers1-img">
          <picture>
            <source media="(min-width: 1024px)" srcSet={coach.coverDesktopXl} type="image/webp" />
            <source media="(min-width: 440px)" srcSet={coach.coverTablette} type="image/webp" />
            <img src={coach.coverMobile} alt={coach.alt} />
          </picture>
        </div>
        <div className="cardTertiary-containerContains-containers2">
          <div className="cardTertiary-containerContains-containers2-descriptions">
            <div className="cardTertiary-containerContains-containers2-descriptions-title">
              <h2>{MyTypo(coach.title)}</h2>
            </div>
            <div className="cardTertiary-containerContains-containers2-descriptions-description1">
              <p>{MyTypo(coach.description1)}</p>
            </div>
            {/*<div className="cardTertiary-containerContains-containers2-descriptions-listes">
              <ul className="cardTertiary-containerContains-containers2-descriptions-listes-liste">
                {listItems}
              </ul>
            </div>*/}
            <div className="cardTertiary-containerContains-containers2-descriptions-description2">
              <p>{MyTypo(coach.description2)}</p>
            </div>
            <div className="cardTertiary-containerContains-containers2-descriptions-description3">
              <p>{MyTypo(coach.description3)}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="cardTertiary-containerBackground"></div>
    </div>
  );
}

export default CardMobile3;
